const heroImages = document.querySelectorAll('.js-hero-image');

heroImages.forEach((heroImg) => {
    if (heroImg.complete) {
        loaded(heroImg);
      } else {
        heroImg.addEventListener('load', function(){
            loaded(heroImg);
        });
    }      
});

function loaded(heroImg) {
    heroImg.classList.add('loaded');
}